import { AppHelper } from "../../appHelper.js";
import { AppBaseProps, CommonApp, Entity } from "../../core/components/commonApp.js";
import React from "react";

export class AssignmentDistributionPreview extends React.Component<AppBaseProps, any> {
    common = new AppHelper();
    constructor(props) {
        super(props);
        this.common.init(this);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { apphelper: this.common });
        return (<CommonApp {...props} />);
    }
}

export interface AssignmentDistributionPreviewProps extends AppBaseProps {
    entity: PreviewEntity;
}

export interface PreviewEntity extends Entity {
    Assignments: { IsValid: boolean; }[];
    Resources: { IsValid: boolean; }[];
}